import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';
import { GrowerCrudService } from 'src/app/shared/services/grower-crud.service';
import { Grower } from 'src/app/shared/interfaces/grower';

@Component({
  selector: 'app-growers',
  templateUrl: './growers.component.html',
  styleUrls: ['./growers.component.scss']
})
export class GrowersComponent implements OnInit {

  growers: Grower[];
  grower: Grower;
  selectedGrowers: Grower[] = [];

  growerDialog: boolean = false;

  submitted: boolean = false;

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  separatorExp: string = "[,| ]";

  constructor(
    private growerService : GrowerCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Settings'},
      {label: 'Growers'}
    ];

    this.growers = [];
    this.grower = { } as Grower ;
  }

  ngOnInit(): void {

    this.isFilter = false;
    
    this.dataState();
    let s = this.growerService.getList(); 
    s.snapshotChanges().subscribe(data => {
      this.growers = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Grower = jsonItem as Grower;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          this.growers.push(l);
        }
      })
    })

    // column management
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'qrcode', header: 'QRCode' },
      { field: 'description', header: 'Description' },
      { field: 'tags', header: 'Tags' },
      { field: 'isEnabled', header: 'Enabled' },
      { field: 'actions', header: 'Actions' } 
    ];

    // column that we shoa at the beginning
    this._selectedColumns = this.cols;
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'qrcode');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'description');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'isEnabled');

    // Exports
   // this.exportColumns = this.cols.map(col => ( {title: col.header, dataKey: col.field} ) );
   // For the PDF 
   this.exportColumns = this.cols.map(col => {
      if (col.field === 'position' || col.field === 'rank')  
        return {title: col.header, dataKey: 'position'};
      if (col.field !== 'actions')  
        return {title: col.header, dataKey: col.field};
      return {};
    } );
  }

  dataState() {     
    this.growerService.getList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    // console.log('selected columns', this._selectedColumns);
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.growers);
            doc.save('growers.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.growers);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "growers");
    });
  }

  exportDTCSV() {
   // console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => 
      { exportCols.push(sc.field);
        // console.log('SAVEC CSV COL F ',sc.field);
        // console.log('SAVEC CSV COL ',sc);
      });
      exportCols.push('position');
      // console.log('SAVEC CSV SELECTED LOCATIONS ', this.selectedGrowers);
      // console.log('SAVEC CSV LOCATIONS ', this.growers);
      // console.log('SAVEC CSV EXPORT COL ', exportCols);
      this.exportService.exportToCsv(this.selectedGrowers, 'growers', exportCols);
   // this.exportService.exportToCsv(this.growers, 'growers', ['$key', 'name', 'description', 'tags', 'isEnabled', 'actions']);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.grower = {} as Grower;
    this.submitted = false;
    this.growerDialog = true;
  }

  deleteSelectedGrowers() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected growers?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.growers = this.growers.filter(val => !this.selectedGrowers.includes(val));
            this.selectedGrowers = [];
            this.selectedGrowers.forEach( grower => this.growerService.delete(grower.$key));
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Growerss Deleted', life: 3000});
        }
    });
  }

  editGrower(grower: Grower) {
    this.grower = {...grower};
    this.growerDialog = true;
  }

  deleteGrower(grower: Grower) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + grower.name + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.growers = this.growers.filter(val => val.$key !== grower.$key);
            this.grower = {} as Grower;
            this.growerService.delete(grower.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Grower Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.growerDialog = false;
    this.submitted = false;
  }

  saveGrower() {
    this.submitted = true;

    if ( this.grower.name.trim() ) {
      if (this.grower.$key) {
          this.growers[this.findIndexById(this.grower.$key)] = this.grower;                
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'Grower Updated', life: 3000});
          this.growerService.update(this.grower);
        } else {
          this.grower.position = this.growers.length;
          this.growerService.add(this.grower);
      }
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'Grower Created', life: 3000});
      this.growers = [...this.growers];
    }

    this.growerDialog = false;
    this.grower = { } as Grower;
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.growers.length; i++) {
        if (this.growers[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeGrower(grower : Grower) {
    //console.log("SAVE", grower);
    this.growerService.update(grower);
  }

  completePosition(grower : Grower) {
   // console.log("SAVE", grower);
  //  this.growerService.updateGrower(grower);


    if ( this.newPosition > -1 ) {
        grower.position = this.newPosition;
        grower = this.checkPositionLimits(grower);
        this.reorderElements(grower);
        //this.updateDB(grower);
        this.newPosition = -1;
        this.previousPosition = -1;
        return;
      }
  }


  @ViewChild('dt') tableElement: any; // already dt above
  isReordering : boolean = false;
  isAscReordering : boolean = false;
  isFilter : boolean = false;

  // Reorder
  reorder(event: any) {
    //console.log('Reorder event', event);
    // console.log('Before', this.growers);
    // const myClonedArray = [];
    // this.growers.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // console.log('Before2', myClonedArray);
    if (event.dragIndex === event.dropIndex ) {
      return;
    }
    const startIndex = this.isAscReordering? event.dragIndex : this.growers.length - 1 - event.dragIndex;
    const endIndex   = this.isAscReordering? event.dropIndex : this.growers.length - 1 - event.dropIndex;
    const growerToMove = this.growers[startIndex];
    
    
    // console.log('StartIndex', startIndex);
    // console.log('EndIndex', endIndex);

    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {
        this.growers[index] = this.growers[index+1];
        this.growers[index].position = index;
        this.growerService.update(this.growers[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.growers[index] = this.growers[index-1];
        this.growers[index].position = index;
        this.growerService.update(this.growers[index]);
      }
    } 
    this.growers[endIndex] = growerToMove;
    this.growers[endIndex].position = endIndex;
    this.growerService.update(this.growers[endIndex]);
  }

  // onFieldEdit(grower: Spray, fieldName: string): void {
  //   //console.log(this.growers);
  //   console.log("Edit Init Event Called");
  //   console.log('Field name :'+fieldName);
  //   console.log('Field value :' + grower[fieldName]);
  //   if (fieldName === 'position') {
  //     if ( this.newPosition ) {
  //       grower.position = this.newPosition;
  //       grower = this.checkPositionLimits(grower);
  //       this.reorderElements(grower);
  //       //this.updateDB(grower);
  //       this.newPosition = undefined;
  //       this.previousPosition = undefined;
  //       return;
  //     }
      
  //   } else {
  //     this.updateDB(grower);
  //   }
  // }


  ngAfterViewInit() {
    this.dt.onSort.subscribe((data: { field: string; order: number; }) => {
        if (data.field && data.field === "position") {
          this.isReordering = true;
          this.isAscReordering = (data.order == 1);
          // console.log("ASC", this.isAscReordering);
          // console.log("data.order", data.order);
        } else {
          this.isReordering = false;
        }
    });
    this.dt.onFilter.subscribe( (data: {
      filteredValue: {
        [x: string]: any; field: string; order: number; 
}; field: string; order: number; 
}) => {
      if (data && data.filteredValue) {
        this.isFilter = !(this.growers.length === data.filteredValue['length']);
      } else {
        this.isFilter = false;
      }
  });
  
}


  previousPosition : number = -1;
  newPosition : number = -1;

  modelChangeFn(event: number, grower: Grower) {
    // console.log("event" +event);
    if (grower.position != null && grower.position > -1) {
      this.previousPosition = grower.position;
      this.newPosition = event;
    }
   
    // console.log("previous" +this.previousPosition);
    // console.log("new" +this.newPosition);
  }

  checkPositionLimits(grower: Grower) {
    console.log('check ',grower.position + ' ' + this.growers.length);
    if (!grower.position) {
     // console.log('check 1');
      return this.grower;
    }
    if (grower.position < 0) {
      grower.position = 0;
      // console.log('check 2');
      return grower;
    }
    if (grower.position > this.growers.length) {
      grower.position = this.growers.length - 1;
    //  console.log('check 3', grower.position);
      return grower;
    }
   // console.log('check 4');
    return grower;
  }

  async reorderElements(grower: Grower) {
    this.newPosition = this.newPosition  > this.growers.length ? this.growers.length - 1 : this.newPosition;
    this.newPosition = this.newPosition  < 0 ? 0 : this.newPosition;
    if (this.previousPosition === grower.position ) {
      return;
    }
    // console.log('Previous position: '+ this.previousPosition);
    // console.log('New position: '+ this.newPosition);
    const startIndex = this.previousPosition;
    const endIndex   = this.newPosition;
    const growerToMove = this.growers[startIndex];
   // console.log('Item to move: ', this.growers[startIndex]);
    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {

        console.log('LOC', this.growers);
        console.log('Item to +1: ', this.growers[index+1]);

        this.growers[index] = this.growers[index+1];
        this.growers[index].position = index;
        // console.log('Move: ', this.growers[index+1]);
        // console.log('Move pos: ', this.growers[index].position);
        //await this.updateDB(this.growers[index]);
        this.growerService.update(this.growers[index]);
     //   console.log('Update DB: ', this.growers[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.growers[index] = this.growers[index-1];
        this.growers[index].position = index;
        this.growerService.update(this.growers[index]);
      }
    } 
    this.growers[endIndex] = growerToMove;
    this.growers[endIndex].position = endIndex;
    this.previousPosition = -1;
    this.newPosition = -1;
    this.growerService.update(this.growers[endIndex]);
    
    // const myClonedArray = [];
    // this.growers.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // this.growers = myClonedArray;
   // this.getAllRecords();
  }
}
